import { Component, ViewChild } from '@angular/core';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { PlantDto } from 'src/app/dtos/plant-dto';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-inventary',
    templateUrl: './inventary.component.html',
    styleUrls: ['./inventary.component.scss']
})

export class InventaryComponent {

    search: any;
    @ViewChild('tableChild') tableChild: DataTableComponent<PlantDto>;
    pagePath = 'api/plant/page';
    searchText = '';
    options = {
        columnTitles: ['INVENTARY.TABLE.ID', 'INVENTARY.TABLE.NAME' , 'INVENTARY.TABLE.COMPANY', 'GENERAL.LABELS.ACTIONS'],
        columnReferences: ['id', 'name', 'companyName', 'actions'],
        actionButtons: { edit: true, delete: true }
    };

    // Prototipo
    dataSource: any[] = [{ id: 1, name: 'Test', companyName: 'Company' }];
    // ---------

    constructor(private router: Router, public dialog: MatDialog, private apiService: ApiService, 
        private messageService: MessageService) { }

    goToEdit(e: any) {
        this.router.navigate(['inventary/edit', e.id]);
    }

    openDeleteDialog(e: any) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '680px',
            data: {
                title: 'DIALOGS.DELETE_INVENTARY.TITLE',
                body: 'DIALOGS.DELETE_INVENTARY.BODY',
                cancelButtonText: 'GENERAL.LABELS.CANCEL',
                confirmButtonText: 'GENERAL.LABELS.DELETE',
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                /*this.apiService.delete('api/plant/' + e.id).subscribe(data => {
                    this.messageService.success('USERS.MESSAGES.SUCCESS', 'PLANT.MESSAGES.REMOVED');
                    this.tableChild.loadPage();
                }, error => {
                    this.messageService.error('Error', error.message);
                });*/
            }
        });
    }

    searchPant() {
        this.search = {
            searchText: this.searchText
        };
        this.tableChild.firstPage();
        this.tableChild.loadPage(this.search);
    }

}
